module.exports = __webpack_public_path__ + "img/10-5.1ad15a7b.png";